<template>
    <div>
        <base-button-flat
            @click="viewAll"
            variant="secondary"
            class="h-9 px-4 text-sm"
        >
            {{ $t('VIEW_ALL') }}
        </base-button-flat>

        <view-all-list
            :is-open="showOverlay"
            @overlayClose="showOverlay = false"
        />
    </div>
</template>

<script>
    import BaseButtonFlat from './BaseButtonFlat.vue';
    import ViewAllList from './ViewAllList.vue';

    export default {
        components: {
            BaseButtonFlat,
            ViewAllList,
        },

        data() {
            return {
                showOverlay: false,
            };
        },

        methods: {
            viewAll() {
                this.showOverlay = true;
            },
        },
    };
</script>
